import Box from '@mui/material/Box'
import GradeIcon from '@mui/icons-material/Grade'
import ReactCountryFlag from 'react-country-flag'

const ActivityMetaData = ({ name, review, countryCode, subtitle }) => {
  if (countryCode) {
    var country = `https://flagcdn.com/16x12/${countryCode.toLowerCase()}.png`
    var country_2x = `https://flagcdn.com/16x12/${countryCode.toLowerCase()}.png 3x`
    var country_3x = `https://flagcdn.com/16x12/${countryCode.toLowerCase()}.png 3x`
  }
  return (
    <>
      {review.avg_review !== 0 && (
        <Box
          sx={{
            display: 'flex',
            color: '#28AB83',
            alignItems: 'center',
            px: 3,
            marginTop: '8px',
          }}
        >
          <GradeIcon
            sx={{
              mr: 0.5,
              fontWeight: 400,
              fontSize: 15,
              // lineHeight: 150,
            }}
          />
          <p
            style={
              {
                // fontWeight: 590,
                // fontSize: '15px',
                // lineHeight: '150%',
                // letterSpacing: '-0.005em',
              }
            }
            className="headline2"
          >
            {review.avg_review + '/5'}
          </p>
        </Box>
      )}
      <p
        style={{
          marginTop: review.avg_review === 0 ? '16px' : '0px',
          marginBottom: '8px',
          textAlign: 'left',
          // listStyle: 'none',
          // fontWeight: 700,
          // fontSize: '20px',
          lineHeight: '140%',
          color: 'var(--gray100)',
          padding: '0 20px 0 20px',
        }}
        className="title2"
      >
        {name}
      </p>
      <div
        style={{
          // marginTop: '-10px',
          // marginBottom: '20px',
          textAlign: 'left',
          listStyle: 'none',
          color: 'var(--gray80)',
          padding: '0 20px 0 20px',
        }}
      >
        <p className="body3">
          {' '}
          {subtitle}
          {countryCode && (
            <span>
              {/* <ReactCountryFlag countryCode={countryCode} svg /> */}
              <img
                src={country}
                srcSet={country_2x + ', ' + country_3x}
                width="16"
                height="12"
              ></img>
            </span>
          )}
        </p>
      </div>
    </>
  )
}

export default ActivityMetaData
